import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { changePassword } from 'src/store/actions/user'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import Loading from 'src/components/Loading/Loading'
import { useParams, useNavigate } from 'react-router'
import './ChangePass.sass'

const ChangePass = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState('')

  const { user, token } = params

  if (!user || !token) navigate('/')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (status === 'loading') return
    if (status === 'success') {
      navigate('/')
      return
    }
    const password = e.target.password.value
    if (!checkPassword(password)) return setStatus('incorrect-password')
    setStatus('loading')
    dispatch(changePassword(user, token, password))
      .then((data) => {
        setStatus('success')
        const secret = data.secret
        window.localStorage.setItem('secret2Factor', secret)
      })
      .catch((e) => {
        if (e.data && e.data.error && e.data.error === 'Incorrect password') {
          setStatus('incorrect-password')
        } else {
          setStatus('error')
        }
      })
  }

  const checkPassword = (pass: string) => {
    const exp = new RegExp(
      '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$'
    )
    return exp.test(pass)
  }

  let messageClass = 'message'
  if (status === 'success') {
    messageClass += ' success'
  } else {
    messageClass += ' error'
  }

  const changeForm = (
    <form onSubmit={handleSubmit} className={status}>
      {status !== 'success' && (
        <label>
          <span className="icon icon-lock" />
          <FormattedMessage id="placeholder.new-password">
            {(text: string) => (
              <input
                type="password"
                name="password"
                placeholder={text}
                required
              />
            )}
          </FormattedMessage>
        </label>
      )}
      <p className={messageClass}>
        {status === 'error' && (
          <span>
            <FormattedMessage id="change-pass.error" />
          </span>
        )}
        {status === 'incorrect-password' && (
          <span>
            <FormattedMessage id="change-pass.incorrect-password" />
          </span>
        )}
        {status === 'success' && (
          <span>
            <FormattedMessage id="change-pass.success" />
          </span>
        )}
      </p>
      <button className="filled" type="submit">
        {status !== 'success' ? (
          <FormattedMessage id="change-pass.button" />
        ) : (
          <FormattedMessage id="continue" />
        )}
      </button>
    </form>
  )

  return (
    <div id="change-pass" className="page split">
      <header className="item left" id="recover-header" />
      <section className="item right" id="recover-content">
        <div className="wrapper">
          <img src="/images/logo.png" alt="logo" />
          <div className="change-pass-form">
            <h2>
              <FormattedMessage id="change-pass.title" />
            </h2>
            <p>
              <MarkdownMessage id="change-pass.description" />
            </p>
            {status !== 'loading' ? changeForm : <Loading />}
          </div>
        </div>
      </section>
    </div>
  )
}

export default ChangePass
